module.exports = __webpack_public_path__ + "img/clap3.a3b73e61.png";